<template>
  <widget-temp :widgetTitle="$t('charts.truck_status_title')" widgetName="TruckStatusChart" v-bind:widgetId="3">
    <template slot="widget-content">
      <div class="chart-container">
        <highcharts :options="chartOptions"></highcharts>
      </div>
    </template>
  </widget-temp>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "truck-status-chart",
  data() {
    return {};
  },
  computed: {
    ...mapState({
      loading: state => state.dashboard.loading,
      truckData: state => state.dashboard.truck_status_chart
    }),
    chartOptions() {
      const colorMap = {
        'Xếp xe': '#10b981', // Emerald green
        'Chờ thông quan VN': '#f43f5e', // Rose red
      };

      const categoryMap = {
        'Xếp xe': this.$t('charts.categories.xep_xe'),
        'Chờ thông quan VN': this.$t('charts.categories.cho_thong_quan_vn'),
      };

      const data = (this.truckData || []).map(item => ({
        name: categoryMap[item.name] || item.name,
        y: item.y,
        color: colorMap[item.name] || item.color
      }));

      return {
        chart: {
          type: 'pie',
          height: 380,
          style: {
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
          }
        },
        title: {
          text: ''
        },
        tooltip: {
          backgroundColor: '#ffffff',
          borderWidth: 1,
          borderColor: '#e2e8f0',
          borderRadius: 8,
          shadow: true,
          useHTML: true,
          pointFormat: `<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y} ${this.$t('charts.unit_xe')}</b>`
        },
        plotOptions: {
          pie: {
            innerSize: '60%',
            borderWidth: 0,
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>:<br/>{point.y} ' + this.$t('charts.unit_xe'),
              style: {
                fontSize: '11px',
                fontFamily: 'inherit',
                fontWeight: '600',
                color: '#475569'
              },
              distance: 15
            },
            showInLegend: true
          }
        },
        series: [{
          name: this.$t('charts.series_quantity'),
          colorByPoint: true,
          data: data
        }],
        legend: {
          enabled: true,
          itemStyle: {
            color: '#64748b',
            fontSize: '11px',
            fontWeight: '500'
          }
        },
        credits: {
          enabled: false
        }
      };
    }
  },
  watch: {
    truckData: {
      handler() {
        this.$nextTick(() => {
          this.$emit('rendered');
        });
      },
      immediate: true
    }
  },
  methods: {
    async getChartData() {
      this.$store.dispatch("dashboard/getTruckStatusChart");
    }
  },
  mounted() {
    this.getChartData();
  }
};
</script>

<style scoped>
.chart-container {
  padding: 20px;
  min-height: 400px;
}
</style>
